import { Switch, Route } from 'react-router-dom'
import Login from './containers/Login'
import ROUTES from './const/routes'
import ProtectedRoute from './containers/ProtectedRoute'
import {
  SuperAdmin,
  BranchAdmin,
  InstituteAdmin,
  Teacher,
  Student,
  Topics,
  Materials,
  TestInstructions,
  Test,
  Results,
  Package,
  Register,
  Live,
  CompletedSessions,
  Chapters,
  Assessment,
  Learn,
  ResetPassword,
  PracticeTest,
  Dashboard,
  UserDetail,
  NewUser,
  Branches,
  AddBranch,
  PublishList,
  PublishMaterial,
  BranchDetail,
  SessionList,
  AddSession,
  BatchList,
  QuestionList,
  AddQuestion,
  AddBatch,
  TestListing,
  TestResults,
  PendingRequests,
  Material,
  AddMaterial,
  Evaluate,
  ReviewQuestions,
  Tests,
  Questions,
  Institute,
  AddInstitute,
  CreateTest,
  CourseList,
  AddCourse,
  TestSetting,
  InstituteDetail,
  ViewBatch,
  ViewSession,
  ViewCourse,
  BulkEntry,
  PurchaseCourse,
  Assignment,
  StudentActivity,
  LessonPlane,
  LearnSession,
  AssignLearnSession,
  StudentRegister,
  ApplyLeave,
  LeaveDetails,
  CreateLeave,
  LeaveMasterDetails,
  ViewLeaveDetail,
  QrList,
  WebCamScanner,
  QRVideo,
  DailyTest,
  AttemptedTests
} from './pages'
import Cache from './pages/admin/Cache' 

const Routes = () => {
  return (
    <Switch>
      <Route exact path={ROUTES.LOGIN} component={Login} />
      <Route exact path={ROUTES.REGISTER} component={Register} />
      <Route exact path={ROUTES.PURCHASE_COURSE} component={PurchaseCourse} />
      <Route exact path={ROUTES.PACKAGE} component={Package} />
      <Route path={ROUTES.RESET_PASSWORD} component={ResetPassword} />
      <ProtectedRoute path={ROUTES.LEARN} component={Learn} />
      <ProtectedRoute path={ROUTES.LIVE} component={Live} />
      <ProtectedRoute path={ROUTES.ASSESSMENT} component={Assessment} />
      <ProtectedRoute path={ROUTES.PRACTICE_TEST} component={PracticeTest} />
      <ProtectedRoute path={ROUTES.CHAPTERS} component={Chapters} />
      <ProtectedRoute path={ROUTES.MATERIAL} component={Materials} />
      <ProtectedRoute path={ROUTES.TOPICS} component={Topics} />
      <ProtectedRoute path={ROUTES.RESULTS} component={Results} />
      <ProtectedRoute
        path={ROUTES.COMPLETED_SESSIONS}
        component={CompletedSessions}
      />
      <ProtectedRoute
        path={ROUTES.TESTINSTRUCTIONS}
        component={TestInstructions}
      />
      <ProtectedRoute path={ROUTES.TEST} component={Test} />
      <ProtectedRoute path={ROUTES.SUPERADMIN} component={SuperAdmin} />
      <ProtectedRoute path={ROUTES.BRANCHADMIN} component={BranchAdmin} />
      <ProtectedRoute path={ROUTES.INSTITUTEADMIN} component={InstituteAdmin} />
      <ProtectedRoute path={ROUTES.TEACHER} component={Teacher} />
      <ProtectedRoute path={ROUTES.STUDENT} component={Student} />
      <ProtectedRoute path={ROUTES.DASHBOARD} component={Dashboard} />
      <ProtectedRoute path={ROUTES.USER_DETAIL} component={UserDetail} />
      <ProtectedRoute path={ROUTES.NEW_USER} component={NewUser} />
      <ProtectedRoute path={ROUTES.BRANCH_LIST} component={Branches} />
      <ProtectedRoute path={ROUTES.BRANCH_ADD} component={AddBranch} />
      <ProtectedRoute path={ROUTES.BRANCH_EDIT} component={AddBranch} />
      <ProtectedRoute path={ROUTES.PUBLISH_LIST} component={PublishList} />
      <ProtectedRoute
        path={ROUTES.PUBLISH_MATERIAL_ADD}
        component={PublishMaterial}
      />
      <ProtectedRoute
        path={ROUTES.PUBLISH_MATERIAL_EDIT}
        component={PublishMaterial}
      />
      <ProtectedRoute path={ROUTES.BRANCH_DETAIL} component={BranchDetail} />
      <ProtectedRoute path={ROUTES.SESSION_LIST} component={SessionList} />
      <ProtectedRoute path={ROUTES.VIEW_SESSION} component={ViewSession} />
      <ProtectedRoute path={ROUTES.ADD_SESSION} component={AddSession} />
      <ProtectedRoute path={ROUTES.EDIT_SESSION} component={AddSession} />
      <ProtectedRoute path={ROUTES.BATCH_LIST} component={BatchList} />
      <ProtectedRoute path={ROUTES.BATCH_ADD} component={AddBatch} />
      <ProtectedRoute path={ROUTES.EDIT_BATCH} component={AddBatch} />
      <ProtectedRoute path={ROUTES.QUESTIONLIST} component={QuestionList} />
      <ProtectedRoute path={ROUTES.ADDQUESTION} component={AddQuestion} />
      <ProtectedRoute path={ROUTES.TEST_LIST} component={TestListing} />
      <ProtectedRoute path={ROUTES.TEST_RESULTS} component={TestResults} />
      <ProtectedRoute
        path={ROUTES.PENDING_REQUESTS}
        component={PendingRequests}
      />
      <ProtectedRoute path={ROUTES.ADMIN_MATERIAL} component={Material} />
      <ProtectedRoute path={ROUTES.ADD_MATERIAL} component={AddMaterial} />
      <ProtectedRoute path={ROUTES.EVALUATE} component={Evaluate} />
      <ProtectedRoute path={ROUTES.REVIEW} component={ReviewQuestions} />
      <ProtectedRoute path={ROUTES.TESTS} component={Tests} />
      <ProtectedRoute path={ROUTES.REVIEWQUESTIONS} component={Questions} />
      <ProtectedRoute path={ROUTES.INSTITUTE} component={Institute} />
      <ProtectedRoute path={ROUTES.ADD_INSTITUTE} component={AddInstitute} />
      <ProtectedRoute path={ROUTES.EDIT_INSTITUTE} component={AddInstitute} />
      <ProtectedRoute
        path={ROUTES.INSTITUTE_DETAIL}
        component={InstituteDetail}
      />
      <ProtectedRoute path={ROUTES.CREATE_TEST} component={CreateTest} />
      <ProtectedRoute path={ROUTES.COURSELIST} component={CourseList} />
      <ProtectedRoute path={ROUTES.ADDCOURSE} component={AddCourse} />
      <ProtectedRoute path={ROUTES.TESTSETTING} component={TestSetting} />
      <ProtectedRoute path={ROUTES.VIEW_BATCH} component={ViewBatch} />
      <ProtectedRoute path={ROUTES.VIEW_COURSE} component={ViewCourse} />
      <ProtectedRoute path={ROUTES.EDIT_COURSE} component={AddCourse} />
      <ProtectedRoute path={ROUTES.STUDENT_BULK_ENTRY} component={BulkEntry} />
      <ProtectedRoute path={ROUTES.ASSIGNMENT} component={Assignment} />
      <ProtectedRoute
        path={ROUTES.STUDENT_ACTIVITY}
        component={StudentActivity}
      />
      <ProtectedRoute path={ROUTES.LESSON_PLANE} component={LessonPlane} />
      <ProtectedRoute path={ROUTES.LEARN_SESSION} component={LearnSession} />
      <ProtectedRoute path={ROUTES.ASSIGNLEARN_SESSION} component={AssignLearnSession} />
      <ProtectedRoute path={ROUTES.CACHE} component={Cache} />
      <ProtectedRoute path={ROUTES.STUDENT_REGISTER} component={StudentRegister} />
      <ProtectedRoute path={ROUTES.APPLY_LEAVE} component={ApplyLeave} />
      <ProtectedRoute path={ROUTES.LEAVE_DETAILS} component={LeaveDetails} />
      <ProtectedRoute
        path={ROUTES.VIEW_LEAVE_STATUS}
        component={ViewLeaveDetail}
      />
      <ProtectedRoute
        path={ROUTES.CREATE_LEAVE}
        component={CreateLeave}
      />
      <ProtectedRoute
        path={ROUTES.LEAVE_MASTER_DETAILS}
        component={LeaveMasterDetails}
      />
      <ProtectedRoute path={ROUTES.QR_LIST} component={QrList} />
      <ProtectedRoute path={ROUTES.WEBCAM_SCANNER} component={WebCamScanner} />
      <ProtectedRoute path={ROUTES.QRVIDEO} component={QRVideo} />
      <ProtectedRoute path={ROUTES.DAILY_TEST} component={DailyTest} />
      <ProtectedRoute path={ROUTES.DAILY_TEST} component={DailyTest} />
      <ProtectedRoute path={ROUTES.ATTEMPETD_TEST} component={AttemptedTests} />
    </Switch>
  )
}

export default Routes
